import { Box, Button, CircularProgress, Typography } from '@mui/material';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ModalSizeE } from 'declarations/enums/modal';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';

import useTicketReopenPopup from './hooks/useTicketReopenPopup';
import { getPopupContentStyle } from './TicketReopenPopup.styled';

type TicketReopenPopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const TicketReopenPopup: FC<TicketReopenPopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const { isReopeningTicket, handleReopenTicket, handleClosePopup } = useTicketReopenPopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn
      modalTitle="Reopen Ticket"
      size={ModalSizeE.CLOSE_TICKET}
      popupId={ScrollLockIdE.TicketReopenPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
        }}
      >
        <Typography variant="body1" color="text.primary" align={isMobile ? 'center' : 'left'}>
          Are you sure you want to reopen this ticket?
        </Typography>
        <Box sx={{ flex: 1, minHeight: 16 }} />
        <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 2, pt: 1 }}>
          <Button
            variant="contained"
            disabled={isReopeningTicket}
            onClick={handleReopenTicket([ticketId], onClose)}
            startIcon={
              isReopeningTicket ? <CircularProgress size={16} color="inherit" /> : undefined
            }
          >
            Reopen
          </Button>
        </Box>
      </Box>
    </Popup>
  );
};

export default TicketReopenPopup;
